import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Environment } from '@desbank/core/src/lib/environment';

export interface Cache {
  url: string;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private storage: Cache[] = [];

  constructor(
    @Inject('environment') private env: Environment
  ) {
    this.cleanCache();
  }

  public get(url: string): Observable<any> {
    return this.fetch(url)?.data;
  }

  public keep(cache: Cache): void {
    if (!this.isCacheable(cache.url)) {
      this.storage.push(cache);
    }
  }

  public isCacheable(url: string): boolean {
    return Boolean(this.fetch(url));
  }

  private fetch(url: string): Cache | undefined {
    return this.storage.find((cache: Cache) => cache.url === url);
  }

  private cleanCache(): void {
    setInterval(() => {
      this.storage = [];
      console.info('Cache cleaned!');
    }, this.env.cacheTime);
  }
}
